type NavObj = {
  container: Element
  button: HTMLButtonElement
  menu: HTMLUListElement
  openedByClick?: boolean
}

let outerNav = document.querySelector(".js-navigation");
let subMenus = outerNav?.querySelectorAll(".js-sub-menu");

let desktopNav = false

const mediaQuery = window.matchMedia('(min-width: 1024px)')

const handleResize = (e: MediaQueryListEvent) => {
  desktopNav = e.matches ? true : false
}

mediaQuery.addEventListener('change', handleResize)

const findMenu = (container: Element) => {
  const button = container.querySelector("button");
  const menu = container.querySelector("ul");
  if (button && menu) {
    return {
      container, button, menu
    } as NavObj;
  }
}

const toggleVisibility = (navObj: NavObj) => {
  const expandedValue = navObj.button.getAttribute("aria-expanded");
  navObj.container.classList.toggle("expanded");
  navObj.menu.toggleAttribute("hidden");
  navObj.button.setAttribute(
    "aria-expanded",
    expandedValue === "false" ? "true" : "false"
  );
}

const openMenu = (navObj: NavObj) => {
  if (navObj.button.getAttribute("aria-expanded") === "false") {
    toggleSubMenus(navObj);
    toggleVisibility(navObj);
  }
}

const closeMenu = (navObj: NavObj) => {
  if (navObj.button.getAttribute("aria-expanded") === "true") {
    toggleVisibility(navObj);
    navObj.openedByClick = false; // reset click state when closed
  }
}

const toggleSubMenus = (menu: NavObj) => {
  if (menu.button.classList.contains("js-submenu-button")) {
    subMenus?.forEach((subMenu) => {
      const thisSubMenu = findMenu(subMenu)
      if (
        thisSubMenu?.button.getAttribute("aria-expanded") === "true" &&
        thisSubMenu?.button.id !== menu.button.id
      ) {
        closeMenu(thisSubMenu);
      }
    });
  }
}

const closeAllMenus = (event: Event) => {
  if (outerNav && !outerNav.contains(event.target as Element)) {
    const outer = findMenu(outerNav)
    if (outer) closeMenu(outer);

    subMenus?.forEach((subMenu) => {
      const thisSubMenu = findMenu(subMenu)
      if (thisSubMenu) closeMenu(thisSubMenu);
    });
  }
}

const addClickHandler = (container: Element) => {
  const menu = findMenu(container)
  if (menu) {
    menu.button.addEventListener("click", () => {
      if (menu.button.getAttribute("aria-expanded") === "false") {
        toggleSubMenus(menu);
        toggleVisibility(menu);
        menu.openedByClick = true; // mark as opened by click
      } else {
        closeMenu(menu);
      }
    });
  }
};

const addHoverHandler = (container: Element) => {
  const menu = findMenu(container)
  if (menu) {
    menu.container.addEventListener("mouseenter", () => {
      if (!menu.openedByClick && desktopNav) {
        openMenu(menu);
      }
    });
    menu.container.addEventListener("mouseleave", () => {
      if (!menu.openedByClick && desktopNav) {
        closeMenu(menu);
      }
    });
  }
};

const navigation = () => {
  outerNav = document.querySelector(".js-navigation");
  subMenus = outerNav?.querySelectorAll(".js-sub-menu");
  desktopNav = mediaQuery.matches ? true : false

  if (outerNav) {
    addClickHandler(outerNav);
    addHoverHandler(outerNav);

    subMenus?.forEach((menu) => {
      addClickHandler(menu);
      addHoverHandler(menu);
    });

    window.addEventListener('click', closeAllMenus);
    window.addEventListener('focusin', closeAllMenus);
  }
}

export default navigation;
